__turbopack_context__.v({
  "fallback": "CatalogRenderer-module__fvkNKa__fallback",
  "fallbackDocsLink": "CatalogRenderer-module__fvkNKa__fallbackDocsLink",
  "fallbackHint": "CatalogRenderer-module__fvkNKa__fallbackHint",
  "fallbackMessage": "CatalogRenderer-module__fvkNKa__fallbackMessage",
  "fallbackTitle": "CatalogRenderer-module__fvkNKa__fallbackTitle",
  "root": "CatalogRenderer-module__fvkNKa__root",
});
